import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-10 mb-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-full bg-gold flex items-center justify-center">
              <span className="font-display font-bold text-navy text-xs">NLS</span>
            </div>
            <p className="font-display font-bold text-navy">NLS Financial Group</p>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            Sophisticated financial architecture for high-income professionals and business owners.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <p className="text-gold text-xs tracking-widest uppercase mb-4">Explore</p>
          <ul className="space-y-2 text-gray-600 text-sm">
            {[["Home", "/"], ["Wealth Design", "/services"], ["The Partnership", "/about"], ["Partner With Us", "/careers"], ["Strategy Audit", "/contact"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="hover:text-gold transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Strategic Partners */}
        <div>
          <p className="text-gold text-xs tracking-widest uppercase mb-4">Strategic Partners</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="https://associateownersgroup.com/" target="_blank" rel="noreferrer" className="text-gray-600 hover:text-gold transition-colors">
                Associate Owners Group (AOG)
              </a>
              <p className="text-gray-400 text-xs mt-0.5">Global IMO Alliance</p>
            </li>
            <li>
              <a href="https://experiorfinancial.com/" target="_blank" rel="noreferrer" className="text-gray-600 hover:text-gold transition-colors">
                Experior Financial Group
              </a>
              <p className="text-gray-400 text-xs mt-0.5">Premier North American IMO</p>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="text-gold text-xs tracking-widest uppercase mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:+19546017475" className="text-gray-600 hover:text-gold transition-colors">
                954-601-7475
              </a>
              <p className="text-gray-400 text-xs mt-0.5">Phone</p>
            </li>
            <li>
              <a href="mailto:nstephens@experiorfinancialgroup.com" className="text-gray-600 hover:text-gold transition-colors break-all">
                nstephens@experiorfinancialgroup.com
              </a>
              <p className="text-gray-400 text-xs mt-0.5">Email</p>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <div>
          <p className="text-gold text-xs tracking-widest uppercase mb-4">Start Your Audit</p>
          <p className="text-gray-500 text-sm mb-4 leading-relaxed">
            Schedule a complimentary Wealth Strategy Audit with our team.
          </p>
          <Link to="/contact" className="btn-gold text-sm" onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}>Book Now</Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 border-t border-gray-200 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-400 text-xs">
          © {new Date().getFullYear()} NLS Financial Group / NLS Wealth Partners. All rights reserved.
        </p>
        <p className="text-gray-400 text-xs text-center md:text-right">
          Securities and insurance products are subject to regulatory requirements. This site is for informational purposes only and does not constitute financial, tax, or legal advice.
        </p>
      </div>
    </footer>
  );
}
